export default "__VITE_ASSET__2319e0b8__"